import { useNavigate } from 'react-router';

import { Block, OneColumn } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { GerarReembolsoFooter, GerarReembolsoGrid, GerarReembolsoGridFilter } from 'pages/financeiro/reembolso/gerar-reembolso/components';

export function GerarReembolsoListComp() {
    const navigate = useNavigate();
    const { getFilterValues } = useListagemContext();
    const { idStatusApuracao } = getFilterValues();
    const isPendente = idStatusApuracao?.statusApuracaoEnum === 'PENDENTE';

    return (
        <OneColumn
            title="Gerar Reembolso"
            goBackButton
            extraButtons={[
                {
                    title: 'Manutenção/Download de Reembolsos',
                    onClick: () => navigate('/financeiro/manutencao-reembolso'),
                    // visible: hasPermission(['']),
                },
            ]}
        >
            <GerarReembolsoGridFilter />

            <Block sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <GerarReembolsoGrid />

                {isPendente && <GerarReembolsoFooter />}
            </Block>
        </OneColumn>
    );
}
